export default __webpack_public_path__ + "static/graphql-benchmarks-8d45428a8bfe02877f66cf8642c8c1c4.svg";